<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isFetchingData" :can-cancel="false"></b-loading>
    <div class="level">
      <div class="level-left">
        <h5 class="title is-5">Your Weekly Profit</h5>
      </div>
      <div class="level-right">
        {{weeklyQuota.percentage}}
      </div>
    </div>
    <progress :class="progressBar" :value="weeklyQuota.totalProfit" :max="weeklyQuota.quota"></progress>
    <p>Weekly quota:
      <strong>{{weeklyQuota.quota}}</strong>
    </p>
    <p>Total profit:
      <strong>{{weeklyQuota.totalProfit}}</strong>
    </p>
  </div>
</template>

<script>
import AppProgress from '../../components/frontend/appProgress'
import axios from 'axios'

const appProgress = new AppProgress()

export default {
  props: ['year', 'month', 'isAdaptive'],
  created() {
    this.getWeeklyQuotaAndProfit()
  },
  watch: {
    year() {
      if (this.year) {
        this.getWeeklyQuotaAndProfit()
      }
    },
    month() {
      if (this.year) {
        this.getWeeklyQuotaAndProfit()
      }
    },
    isAdaptive() {
      this.getWeeklyQuotaAndProfit()
    }
  },
  data: () => ({
    progressBar: appProgress.isDefault(),
    weeklyQuota: {},
    isFetchingData: false
  }),
  methods: {
    getWeeklyQuotaAndProfit() {
      this.weeklyQuota.percentage = '...'
      this.isFetchingData = true
      axios
        .get(
          `api/dashboard/weekly-total-profit-by-month-and-year/${
            this.isAdaptive
          }/${this.year}/${this.month}`
        )
        .then(response => {
          this.weeklyQuota = response.data

          const weeklyQuotaPercentage = this.weeklyQuota.percentage
          if (weeklyQuotaPercentage <= 25) {
            this.progressBar = appProgress.isDanger(true)
          }

          if (weeklyQuotaPercentage <= 50 && weeklyQuotaPercentage > 26) {
            this.progressBar = appProgress.isWarning(true)
          }

          if (weeklyQuotaPercentage <= 75 && weeklyQuotaPercentage > 51) {
            this.progressBar = appProgress.isInfo(true)
          }

          if (weeklyQuotaPercentage <= 99 > weeklyQuotaPercentage > 76) {
            this.progressBar = appProgress.isLink(true)
          }

          if (weeklyQuotaPercentage > 100) {
            this.progressBar = appProgress.isSuccess(true)
          }

          this.weeklyQuota.percentage = `${this.weeklyQuota.percentage}%`
          this.isFetchingData = false
        })
        .catch(error => {
          console.log(error)
          this.weeklyQuota = {}
          this.progressBar = appProgress.isDefault()
        })
        .then(() => (this.isFetchingData = false))
    }
  }
}
</script>
